<template>
    <div
        class="bg-cover bg-center bg-no-repeat pt-32 pb-12 px-2 sm:px-8"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondos_pinguiigluu.jpg')}')`
        }"
    >
        <div class="flex flex-col w-full max-w-screen-lg mx-auto">
            <h2 class="font-secondary text-2xl text-blue font-bold mb-12">
                {{ $config("BIENVENIDO") }}, {{ authenticatedUser.name }}
            </h2>

            <div
                class="flex flex-col items-center w-full max-w-screen-md mx-auto border-2 border-orange px-4 py-16 bg-white"
            >
                <brush-stroke-bg class="mb-16">
                    <h2
                        class="font-primary text-3xl text-white font-semibold py-2 pr-6"
                    >
                        {{ title }}
                    </h2>
                </brush-stroke-bg>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BrushStrokeBg from "../components/BrushStrokeBg";

export default {
    name: "preference-section",

    components: { BrushStrokeBg },

    props: {
        title: {
            type: String,
            required: true
        }
    },

    computed: {
        ...mapState(["authenticatedUser"])
    }
};
</script>
